module.exports = __webpack_public_path__ + "static/Robert_Grant_headshot_lores-08569d0a4c92c13d137f3f686ebfb4d1.png";